module.exports = "<div class=\"wizardChild\" [ngClass]=\"{'active': activeStep.order == order ,'completed': activeStep.order > order}\">\n\t<h5>\n\t\t<span class=\"stepNo\">{{order}}</span>\n\t\t<span>{{title | translate}}</span>\n\t</h5>\n\t<p>{{description | translate}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/things/shared/wizard/wiz-menu-child.component.html
// module id = 1475
// module chunks = 0